import { inject } from '@vercel/analytics'
import '@fontsource/cormorant-garamond/latin-500.css'
import '@fontsource/cormorant-garamond/latin-500-italic.css'
import '@fontsource/nunito-sans/latin-400.css'
import '@fontsource/nunito-sans/latin-600.css'
import '@fontsource/nunito-sans/latin-700.css'
import './src/styles/styles.scss'

// Wire up IntersectionObserver for scroll-reveal on each route
const bindReveal = () => {
    window.__reveal = true;
    const targets =document.querySelectorAll('.reveal:not(.revealed), .reveal-image:not(.revealed)');

    if (typeof IntersectionObserver === 'undefined') {
        targets.forEach((el) => el.classList.add('revealed'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    targets.forEach((el) => observer.observe(el));
};

// Anonymous page view counts. Web Analytics must be enabled on the Vercel project,
// and the privacy policy describes what this records, so keep the two in step.
export const onClientEntry = () => {
    inject();
};

export const onRouteUpdate = () => {
    // Wait a frame so the new route's DOM is in place
    requestAnimationFrame(bindReveal);
};
